import lodashArray from 'lodash/array';
import axiosInstance from '../axiosInstance';
import Auth from '../modules/auth';

export const getCounties = async () => {
  try {
    var token = await Auth.getToken();
    const counties = await axiosInstance.get('/nomenclatures/counties',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    const uniqCounties = lodashArray.uniqBy(counties.data, judet => judet.CodJudet);
    const formattedCounties = uniqCounties.map(county => {
      return {
        code: county.CodJudet,
        name: county.DenJudet,
      };
    });
    return formattedCounties;
  } catch (error) {
    console.error(error);
  }
};

export const getMaternities = async countyCode => {
  try {
    var token = await Auth.getToken();
    const maternities = await axiosInstance.get(`/nomenclatures/hospitals?countyCode=${countyCode}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return maternities.data.spitale.map(hospital => hospital.nume);
  } catch (error) {
    console.error(error);
  }
};

export const getReasons = async () => {
  try {
    var token = await Auth.getToken();
    const reasons = await axiosInstance.get('/nomenclatures/reasons',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return reasons.data.map(reason => reason.name);
  } catch (error) {
    console.error(error);
  }
};

